module.exports = __webpack_public_path__ + "static/media/favicon.c0b4f1cd.ico";